module.exports = __webpack_public_path__ + "static/img/honor2.dfc9158.png";


//////////////////
// WEBPACK FOOTER
// ./static/aboutUs/honor2.png
// module id = ZbMq
// module chunks = 1